import { useContext } from 'react';
import { ServicesContextObject } from '../context/ServicesContextObject';

/**
 * Custom hook to access the `ServicesContext` context.
 *
 * @throws {Error} Throws an error if used outside of a `ServicesDataProvider`.
 * @returns The value provided by `ServicesContext`.
 */
export const useServices = () => {
  const context = useContext(ServicesContextObject);
  if (!context) {
    throw new Error('useServices must be used within a ServicesDataProvider');
  }
  return context;
};
